import wixData from 'wix-data';

export function parseSecXml(xml, limit) {
	let items = [];
	let datesRaw = xml.match(/<filing-date>([^<]*)<\/filing-date>/g);
	let filingsRaw = xml.match(/<filing-type>([^<]*)<\/filing-type>/g);
	let descriptionsRaw = xml.match(/<title>([^<]*)<\/title>/g);
	let fileHtmlRaw = xml.match(/<filing-href>([^<]*)<\/filing-href>/g);
	let accessionNumsRaw = xml.match(/<accession-number>([^<]*)<\/accession-number>/g);
	let idsRaw = xml.match(/<id>([^<]*)<\/id>/g);

	items.push({
		_id: idsRaw,
		description: descriptionsRaw,
		filing: filingsRaw,
		dates: datesRaw,
		fileHtml: fileHtmlRaw,
		accessionNum: accessionNumsRaw
	});
	
	let itemsParsed = [];

	limit = (limit === 0) ? 10 : limit;

	if (!items[0].dates) {
		return [];
	}
	
	items[0]['dates'].slice(0, limit).forEach( function (item, i) {
		
		itemsParsed.push({
			_id: items[0]._id[i].slice(4, -5).substr(items[0]._id[i].slice(4, -5).length - 6),
			dateFiled: items[0].dates[i].slice(13, -14),
			description: items[0].description[i].slice(7, -8),
			filing: items[0].filing[i].slice(13, -14),
			fileHtml: items[0].fileHtml[i].slice(13, -14),
			accessionNum: items[0].accessionNum[i].slice(18, -19)
	    });
	});
	
	return itemsParsed;
}

export async function saveSecFilings(items) {
	return wixData.query("secData")
		.find()
		.then((results) => {
			results._items.forEach( async (result, index) => {
				console.log('new sec' + JSON.stringify(items[index]))
				await updateSecEntry(result._id, items[index]);
			});
		})
		.catch( (err) => {
			let errorMsg = err;
		});

}


async function updateSecEntry(id, item) {
	let toSave = {
		"_id": id,
		"dateFiled": convertSecItemDate(item.dateFiled),
		"title": item.description,
		"filing": item.filing,
		"link": item.link
	}

	return wixData.save('secData', toSave)
	.catch( (err) => {
		console.log('failed to save sec entry', err);
	});
}

export function convertSecItemDate(date) {
	let dateArr = date.split('-');
	let year = dateArr[0];
	let day = dateArr[2];
	var objDate = new Date(`${dateArr[1]}/${dateArr[2]}/${dateArr[0]}`),
    
	locale = "en-us",
    month = objDate.toLocaleString(locale, { month: "short" }).toLocaleUpperCase();

	return `${month} ${day}, ${year}`;
}

export function saveSecToDb(toInsert) {
	let options = {
  		"suppressAuth": true
	};

	wixData.insert('secData', toInsert, options)
		.then( (results) => {
			console.log('success');
		})
		.catch( (err) => {
			let errorMsg = err;
		});
}

export function getXbrlLink(dateString) {
	const xbrlEligible = [
								{date: 'APR 09, 2019', link: "http://static.wixstatic.com/archives/b595f6_3613a721692d41109ec321b717b929a2.zip"},
								{date: 'APR 02, 2020', link: "https://67182f64-9852-40fd-a33b-1ca81f654b83.usrfiles.com/archives/67182f_c0e0752c533a4b94990c82852f5ea647.zip"} 
		];

	const xbrlItem = xbrlEligible.find(item => dateString === item.date);	
	return xbrlItem && xbrlItem.link;
}